import { useLocation } from 'react-router-dom';
import TextWinds from '../../../components/common/TextWinds';
import '../../../styles/mypage/mypage.css';
import { orderDetailType } from '../../../constants/types/mypage-type';
import { phoneFormat } from '../../../api/utils/format/numbers';
import OrderDetailLayout from './OrderDetailLayout';

const DeliveryInfo = ({ orderDetail }: { orderDetail: orderDetailType }) => {
  // const location = useLocation();
  // const orderDetail = location.state;

  return (
    <OrderDetailLayout title="배송지 정보">
      <div className="flex items-center justify-between">
        <TextWinds type="content_body4" color="gray7">
          수령인
        </TextWinds>
        <TextWinds type="content_body4">{orderDetail.receiver}</TextWinds>
      </div>
      <div className="flex items-center justify-between">
        <TextWinds type="content_body4" color="gray7">
          전화번호
        </TextWinds>
        <TextWinds type="content_body4">
          {phoneFormat(orderDetail.contact_no)}
        </TextWinds>
      </div>
      <div className="flex items-center justify-between">
        <TextWinds type="content_body4" color="gray7">
          주소
        </TextWinds>
        <div className="max-w-[180px] text-right">
          <TextWinds type="content_body4">
            {orderDetail.address_1} {orderDetail.address_2}
          </TextWinds>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <TextWinds type="content_body4" color="gray7">
          배송 메시지
        </TextWinds>
        <TextWinds type="content_body4">{orderDetail.message}</TextWinds>
      </div>
    </OrderDetailLayout>
  );
};

export default DeliveryInfo;
